import React, { useCallback, useEffect } from 'react';

import styled, { css } from 'styled-components';

import { Button } from '~/techstyle-shared/react-components';
import { FormattedMessage, useIntl } from '~/techstyle-shared/react-intl';

import errorMessages from './errorMessages';
import {
  useProductDetailCTAContext,
  ProductDetailCTAErrorTypes,
} from './ProductDetailCTAContext';

const Wrapper = styled.div``;

const VIPAddToBagButton = styled(Button)`
  width: 100%;
`;

const labelStyle = css`
  font-size: 18px;
  font-weight: bold;
  letter-spacing: ${-0.4 / 18}em;
  color: ${({ theme }) => theme.colors.textLight};
`;

function VIPAddToBag({ ...rest }) {
  const {
    addToCart,
    handleSharedValidation,
    isLoading,
    isOutOfStock,
    onSuccessfulAddToCart,
    setErrorMessage,
    hasError,
  } = useProductDetailCTAContext();
  const intl = useIntl();

  const disabled = isLoading || isOutOfStock;

  useEffect(() => {
    if (!hasError) {
      setErrorMessage(null);
    }
  }, [hasError, setErrorMessage]);

  const handleCTAClick = useCallback(async () => {
    try {
      await handleSharedValidation();
      await addToCart();

      onSuccessfulAddToCart && onSuccessfulAddToCart();
    } catch (error) {
      if (error.message === ProductDetailCTAErrorTypes.SelectorError) {
        setErrorMessage(intl.formatMessage(errorMessages.sizeSelectorError));
      }
    }
  }, [
    handleSharedValidation,
    addToCart,
    onSuccessfulAddToCart,
    setErrorMessage,
    intl,
  ]);

  return (
    <Wrapper {...rest}>
      <VIPAddToBagButton
        variant="primaryAddToBag"
        data-autotag="pdp-add-to-cart"
        data-cnstrc-btn="add-to-cart"
        labelStyle={labelStyle}
        onClick={handleCTAClick}
        disabled={disabled}
      >
        {isOutOfStock ? (
          <FormattedMessage
            id="global_cta.out_of_stock"
            defaultMessage="Out of Stock"
          />
        ) : (
          <FormattedMessage
            id="site_pdp.add_to_cart"
            defaultMessage="Add to Bag"
          />
        )}
      </VIPAddToBagButton>
    </Wrapper>
  );
}

export default VIPAddToBag;
